import React from 'react';
import SlideRightDialog from './SlideRightDialog';
import styled from 'styled-components';

// 스타일드 컴포넌트로 iframe 래퍼 생성
const StyledIframeWrapper = styled.div`
  // transform: scale(0.47);
  // width: 220%;
  // height: 213%;
  // background: #fff;
  // transform-origin: 0 0;

  height: 100%;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
`;

const IframeViewer = ({ isOpen, onClose, file = '', style = {} }) => {
  return (
    <SlideRightDialog
      isOpen={isOpen}
      onClose={onClose}
      contentStyle={{ padding: '10px', height: 'calc(100% - 64px)', ...style }}>
      <StyledIframeWrapper>
        <iframe src={file} className="scrollbar" />
      </StyledIframeWrapper>
    </SlideRightDialog>
  );
};

export default IframeViewer;
